import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_REPORTS_API_URL,
  headers: {
    "X-Request-Source": "client",
    "x-api-key": process.env.REACT_APP_REPORTS_API_KEY,
  },
});
